module.exports = __webpack_public_path__ + "static/media/BrownDrownin.51c3432f.jpg";